import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faRocket } from '@fortawesome/free-solid-svg-icons';
import defaultLogo from 'assets/icons/logo.png';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';
import { useBranding } from 'modules/App/hooks/useBranding';
import { useMockData } from '../state/MockDataContext';
import { useUpgradeModal } from './UpgradeModal';

// - onMenuClick (Q5, S7 fix batch 3): opens the mobile nav overlay
//   (MobileNavDrawer, rendered by LiteShell) — only present/visible below
//   `md`, where LiteSidebar's fixed rail is hidden entirely.
export default function LiteHeader({ onMenuClick }) {
  const { t } = useTranslation('freeSupplier');
  const { data } = useMockData();
  const { openUpgrade } = useUpgradeModal();
  const history = useHistory();
  const brand = useBranding();

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-slate-200 z-[110] flex items-center gap-2 sm:gap-3 px-3 sm:px-4">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label={t('header.openNavMenu', 'Open navigation menu')}
        className="md:hidden shrink-0 w-9 h-9 rounded-xl flex items-center justify-center text-slate-500 hover:bg-slate-100 border-0 bg-transparent transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primaryColor/50"
      >
        <FontAwesomeIcon
          icon={faBars}
          className="text-base"
        />
      </button>

      <img
        src={brand.logoUrl || defaultLogo}
        alt={t('header.logoAlt', '{{brandName}} logo', { brandName: brand.name })}
        className="h-9 cursor-pointer shrink-0"
        onClick={() => history.push('/supplier')}
      />
      <span className="hidden md:block w-px h-6 bg-slate-200" />
      <span className="hidden md:block text-sm font-semibold text-slate-700 truncate">
        {data.company.name}
      </span>
      <span className="hidden sm:inline-block text-[10px] font-bold uppercase tracking-wider text-secondaryColor bg-secondaryColor/10 rounded-full px-2 py-0.5 shrink-0">
        {t('header.freePlanBadge', 'Free plan')}
      </span>

      <div className="flex-1" />

      <CgRadixButton
        variant="primary"
        icon={faRocket}
        onClick={() => openUpgrade('generic')}
      >
        <span className="hidden sm:inline">{t('header.upgradeButton', 'Upgrade')}</span>
      </CgRadixButton>
    </header>
  );
}
